import React from "react";
import type { FC } from "react";
import UtilityPanel from "../layout/UtilityPanel";
import CorePanelFooter from "../layout/CorePanelFooter";
import CoreLayout from "../layout/CoreLayout";
import { IconCaution } from "../icons";
import Button from "../form/Button";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "../../store/appStore";
import { jumpToSessionStatus } from "../../api/api";
import { withErrorBoundary } from "../components/withErrorBoundary";

interface Props {
    cancelSession: () => void;
}

const MfaCodeMaxAttemptsError: FC<Props> = (props) => {
    const { setSessionStatus } = useAppStore();
    const navigate = useNavigate();

    function onNext() {
        props.cancelSession();
        setSessionStatus("CANCELLED");
    }

    const header = (
        <div className="self-stretch inline-flex justify-start items-center gap-3">
            <IconCaution />
            <div className="flex-1 justify-start font-normal font-['Inter']">
                <div className="text-king-red text-base">
                    You have entered an incorrect one-time PG&E authentication
                    code too many times
                </div>
            </div>
        </div>
    );

    return (
        <CoreLayout>
            <UtilityPanel headerOverride={header}>
                <div className="flex flex-col gap-4">
                    <div className="text-black text-xs font-normal font-['Inter']">
                        Please try again later to avoid being locked out of your account.
                    </div>
                    
                    <div className="w-full flex justify-end">
                        <Button onClick={onNext} type="primary">
                            Back to Login Step
                        </Button>
                    </div>
                </div>
            </UtilityPanel>
        </CoreLayout>
    );
};

export default withErrorBoundary(MfaCodeMaxAttemptsError);
